"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const console_1 = require("../../../../reducers/slices/console");
const main_1 = require("../../../../reducers/slices/main");
const react_router_dom_1 = require("react-router-dom");
const get_document_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_document_thunk");
const constants_1 = require("../../../../constants/constants");
const document_editor_1 = require("./components/document_editor");
const live_document_1 = require("./components/live_document");
const update_document_thunk_1 = require("../../../../reducers/slices/document/thunks/update/update_document_thunk");
const access_auth_thunk_1 = require("../../../../reducers/slices/user/thunks/access_auth_thunk");
const DocumentPage = () => {
    const { document_id, type } = (0, react_router_dom_1.useParams)();
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const access_code = searchParams.get("access_code");
    const [init, setInit] = (0, react_1.useState)(true);
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { selectedDocument, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const [elements, setElements] = (0, react_1.useState)([]);
    const { user, token } = (0, react_redux_1.useSelector)((state) => state.userState);
    (0, react_1.useEffect)(() => {
        if (token) {
            dispatch((0, console_1.setPageTitle)("Document"));
            if (screen.width < 1900) {
                dispatch((0, console_1.setShowMenu)(false));
            }
        }
    }, [token]);
    (0, react_1.useEffect)(() => {
        if (selectedDocument && selectedDocument._id === document_id && init && selectedDocument.status !== "COMPLETED" && type !== constants_1.TYPE_LINK) {
            setInit(false);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(getLocation, () => alertError("Unable to retrieve your location"));
            }
            else {
                alertError("Geolocation is not supported");
            }
        }
    }, [selectedDocument, document_id]);
    function getLocation(position) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;
            let signers = [];
            // Note: Location verification is now handled server-side during document signing
            // We no longer store location in the document during editing phase
            // Location is captured and verified when mark_signer_complete is called
            if ((selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers.length) > 0) {
                signers = (_a = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) === null || _a === void 0 ? void 0 : _a.map((x) => {
                    if (x.email === user.email) {
                        return Object.assign(Object.assign({}, x), { 
                            // Store coordinates for reference during editing (not signed yet)
                            latitude: lat, longitude: lon });
                    }
                    return x;
                });
            }
            else {
                signers.push({
                    first_name: user.name,
                    last_name: user.surname,
                    email: user.email,
                    // Store coordinates for reference during editing (not signed yet)
                    latitude: lat,
                    longitude: lon,
                });
            }
            dispatch((0, update_document_thunk_1.update_document_thunk)({
                data: {
                    _id: selectedDocument._id,
                    payload: {
                        only_signer: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.only_signer,
                        signers,
                    },
                },
            }));
        });
    }
    function alertError(message) {
        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong!", messages: [message] }));
    }
    (0, react_1.useEffect)(() => {
        const loadDocument = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            // If accessing via link without being logged in, redirect to login
            if (!token && type === constants_1.TYPE_LINK) {
                // Store the current URL so we can return after login
                const returnUrl = window.location.hash;
                navigate(`/entry/sign-in?returnUrl=${encodeURIComponent(returnUrl)}`);
                return;
            }
            // Simplified authentication: FaceTec only required at login
            // JWT token is now sufficient for all document operations (view, edit, sign)
            // Backend PR #40 removed document-level FaceTec middleware
            if (token && document_id) {
                // If access code is present, validate it first
                if (access_code && type === constants_1.TYPE_LINK) {
                    try {
                        const result = yield dispatch((0, access_auth_thunk_1.get_access_details_thunk)({
                            data: { code: access_code },
                            token,
                        })).unwrap();
                        // Check for authentication conflict (wrong user logged in)
                        if ((_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.wrongUser) {
                            const { intendedEmail, currentEmail } = result.error;
                            console.error("❌ Authentication conflict - wrong user logged in");
                            // Show helpful error message
                            dispatch((0, main_1.setMessageModal)({
                                title: "Wrong Account",
                                messages: [
                                    `This link is for ${intendedEmail || "a different user"}.`,
                                    `You are currently logged in as ${currentEmail || "another user"}.`,
                                    "",
                                    "Please log out and sign in with the correct account, then click the link again.",
                                ],
                            }));
                            // Optionally redirect to login after user dismisses modal
                            // navigate('/entry/sign-in');
                            return;
                        }
                        // Only load document after successful access code validation
                        if (result && !result.error) {
                            dispatch((0, get_document_thunk_1.get_document_thunk)({
                                data: {
                                    _id: document_id,
                                },
                            }));
                        }
                        else {
                            console.error("❌ Access code validation returned error:", result === null || result === void 0 ? void 0 : result.error);
                            dispatch((0, main_1.setMessageModal)({
                                title: "Access Denied",
                                messages: ["Invalid or expired access code. Please request a new document link."],
                            }));
                        }
                    }
                    catch (error) {
                        console.error("❌ Access code validation failed:", error);
                        dispatch((0, main_1.setMessageModal)({
                            title: "Access Denied",
                            messages: ["Invalid or expired access code. Please request a new document link."],
                        }));
                    }
                }
                else {
                    // No access code - load document directly
                    dispatch((0, get_document_thunk_1.get_document_thunk)({
                        data: {
                            _id: document_id,
                        },
                    }));
                }
            }
        });
        loadDocument();
    }, [type, token, document_id, access_code]);
    // Simplified FaceTec authentication flow (PR #40):
    // - FaceTec only required at LOGIN (backend removed document-level middleware)
    // - JWT token is sufficient for all document operations (view, edit, sign)
    // - Field-level authorization handled by backend logic and frontend UI restrictions
    if (selectedDocument) {
        if (type) {
            // TYPE_LINK means user is viewing/signing via email link
            return react_1.default.createElement(live_document_1.LiveDocumentPage, Object.assign({}, { document_id, type }));
        }
        // Document editor for owners
        return react_1.default.createElement(document_editor_1.DocumentEditorPage, Object.assign({}, { document_id }));
    }
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { progressColor: "text-primary", size: "large" })));
};
exports.DocumentPage = DocumentPage;
